import React, { useState, useRef } from 'react';
import { toast } from 'react-toastify';
import config from "../../config";

const AddTenantForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    companyName: '',
    email: '',
    subdomain: '',
    dbName: '',
    contactNumber: '',
    address: '',
    city: '',
    state: '',
    country: '',
    pincode: '',
  });

  const offcanvasRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${config.API_BASE_URL}/api/master/newtenant/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) throw new Error('Failed to add tenant');

      // Close the offcanvas
      const offcanvas = window.bootstrap.Offcanvas.getInstance(offcanvasRef.current);
      offcanvas?.hide();

      toast.success('Client added successfully!');
    } catch (error) {
      console.error('Error:', error);
      toast.error('An error occurred while adding the client.');
    }
  };

  return (
    <div
      ref={offcanvasRef}
      className="offcanvas offcanvas-end"
      tabIndex={-1}
      id="offcanvasAddTenant"
      aria-labelledby="offcanvasAddTenantLabel"
    >
      <div className="offcanvas-header">
        <h5 className="offcanvas-title">Add New Client</h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={onClose}
        />
      </div>
      <div className="offcanvas-body">
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Company Name</label>
            <input
              type="text"
              name="companyName"
              className="form-control"
              value={formData.companyName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Subdomain</label>
            <input
              type="text"
              name="subdomain"
              className="form-control"
              value={formData.subdomain}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Database Name</label>
            <input
              type="text"
              name="dbName"
              className="form-control"
              value={formData.dbName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              name="email"
              className="form-control"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Contact Number</label>
            <input
              type="tel"
              name="contactNumber"
              className="form-control"
              value={formData.contactNumber}
              onChange={handleChange}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Address</label>
            <textarea
              name="address"
              className="form-control"
              value={formData.address}
              onChange={handleChange}
              rows="3"
            />
          </div>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">City</label>
              <input
                type="text"
                name="city"
                className="form-control"
                value={formData.city}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">State</label>
              <input
                type="text"
                name="state"
                className="form-control"
                value={formData.state}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Country</label>
              <input
                type="text"
                name="country"
                className="form-control"
                value={formData.country}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Pincode</label>
              <input
                type="text"
                name="pincode"
                className="form-control"
                value={formData.pincode}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="d-grid">
            <button type="submit" className="btn btn-success">
              Add Tenant
            </button>
          </div>
        </form>
      </div>
    </div>
    
  );
};

export default AddTenantForm;
